// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2iFoX","rootCenter":"LoadMoreObserver_rootCenter__3Yyyh","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__XuoIe"};